<template>
  <div id="app" :class="getSubSystemClass()">
    <title>スケジュール管理システム Philips SMS</title>
    <!--
    <ul>
      <li><router-link to="/ReportTrilogy">帳票(トリロジー)</router-link></li>
      <li><router-link to="/AppSelectStaff">担当者検索(部品)</router-link></li>
    </ul>
    -->
    <router-view />
    <b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
  </div>
</template>

<script>
import "quagga";
export default {
  name: "App",
  methods: {
    loadingStart: function() {
      this.isLoading = true;
    },
    loadingEnd: function() {
      this.isLoading = false;
    }
  },
  data() {
    return {
      isLoading: false
    };
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #061e57;
  height: 100%;
}
</style>
<style lang="scss">
// Import Bulma's core
@import "~bulma/sass/utilities/_all";

@import "../scss/color";

// Set your colors
$primary: #061e57;
$primary-invert: findColorInvert($primary);
$info: #209cee;
$info-invert: findColorInvert($info);
$light: whitesmoke;
$light-invert: findColorInvert($light);
$success: #23d160;
$success-invert: findColorInvert($success);
$danger: #ff3860;
$danger-invert: #fff;
$pink: #ffc0cb;
$pink-invert: findColorInvert($pink);
$purple: #9370db;
$purple-invert: findColorInvert($purple);
$background: #199fae;

// Setup $colors to use as bulma classes (e.g. 'is-twitter')
$colors: (
  "white": (
    $white,
    $black
  ),
  "black": (
    $black,
    $white
  ),
  "light": (
    $light,
    $light-invert
  ),
  "dark": (
    $dark,
    $dark-invert
  ),
  "primary": (
    $primary,
    $primary-invert
  ),
  "info": (
    $info,
    $info-invert
  ),
  "success": (
    $success,
    $success-invert
  ),
  "warning": (
    $warning,
    $warning-invert
  ),
  "danger": (
    $danger,
    $danger-invert
  ),
  "red": (
    $danger,
    $black
  ),
  "green": (
    $success,
    $black
  ),
  "yellow": (
    $warning,
    $black
  ),
  "pink": (
    $pink,
    $pink-invert
  ),
  "purple": (
    $purple,
    $black
  ),
  "blue": (
    $info,
    $black
  )
);

// Links
$link: $primary;
$link-invert: $primary-invert;
$link-focus-border: $primary;

$size-medium: $size-6;

// Import Bulma and Buefy styles
@import "~bulma";
@import "~buefy/src/scss/buefy";

table {
  font-size: 0.75rem !important;
}

.searchTitle {
  background-color: #000894;
  color: whitesmoke;
  text-align: center;
}
// b-checkbox-buttonグループの自動折り返し
.checkboxButtonField {
  flex-wrap: wrap;
}
.checkboxButtonField > .control {
  margin-bottom: 0px;
}
// b-buttonのアイコンサイズ
button > span > i {
  font-size: 20px;
}
//タブ選択時の色
.tabs.is-boxed li.is-active a {
  background-color: #199fae;
  border-color: #dbdbdb;
  border-bottom-color: transparent !important;
}
</style>



// WEBPACK FOOTER //
// src/components/App.vue